import { Select } from "chakra-react-select";
import { t } from "i18next";
import * as React from "react";

function MultiSelectFilter(column, params) {
  if (column && params && typeof column !== "undefined" && typeof params !== "undefined") {
    const { id } = column;
    const { options, filterObj, setFilterObj, isClearable = true } = params;

    return <Select
      isClearable={isClearable}
      value={filterObj[id] ?? []}
      onChange={(e) => {
        if (setFilterObj) {
          setFilterObj({
            attribute: id,
            value: e
          });
        }
      }}
      options={options}
      placeholder={t("buttons.searchPlaceholder")}
      isMulti
      className="chakra-react-select"
      classNamePrefix="chakra-react-select"
      chakraStyles={{
        dropdownIndicator: (provided) => ({
          ...provided,
          bg: "transparent",
          px: 2,
          cursor: "inherit"
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: "none"
        }),
        container: (provided) => ({
          ...provided,
          marginTop: "10px",
          fontSize: "md",
          fontWeight: "normal",
          textTransform: "initial",
          letterSpacing: "initial"
        }),
        control: (provided) => ({
          ...provided,
          borderRadius: "none"
        }),
        menuList: (provided) => ({
          ...provided,
          borderRadius: "none",
          minWidth: "100%",
        }),
        option: (provided) => ({
          ...provided,
          _hover: {
            backgroundColor: "gray.100"
          },
        })
      }}
    />;
  }

  return null;
}

export default MultiSelectFilter;